module.exports = __webpack_public_path__ + "img/437.8f1a32cc.png";